import request from './request';

export function getForms() {
  return request({
    path: `/v1/forms`,
  });
}

export function findForm(id) {
  return request({
    path: `/v1/forms/${id}`,
    type: 'get',
  });
}

export function createForm(attrs = {}) {
  return request({
    path: `/v1/forms`,
    type: 'post',
    json: attrs,
  });
}

export function updateFormFields(id, attrs) {
  const {
    action_label,
    action_url,
    fallback_url,
    fields,
    name,
    success_message,
    theme,
    title,
  } = attrs;

  return request({
    path: `/v1/fields/bulk`,
    type: 'put',
    json: {
      form_id: id,
      action_label,
      action_url,
      fallback_url,
      fields,
      name,
      success_message,
      theme,
      title,
    },
  });
}

export function updateForm(id, attrs) {
  return request({
    path: `/v1/forms/${id}`,
    type: 'put',
    json: attrs,
  });
}

export function deleteForm(id) {
  return request({
    path: `/v1/forms/${id}`,
    type: 'delete',
  });
}

export function cloneForm(id) {
  return request({
    path: `/v1/forms/${id}/clone`,
    type: 'post',
  });
}

export function getSalesforceObjectFields(formId, object_type) {
  return request({
    path: `/v1/forms/${formId}/connectors/salesforce/object-fields/${object_type}`,
  });
}

export function autofillForm(id, email) {
  return request({
    path: `/v1/forms/${id}/autofill?email=${encodeURIComponent(email)}`,
    type: 'get',
  });
}
